export type Operator = "equals" | "contains" | "notEquals";

export type CubeRawRow = Record<string, string | number | undefined>;

export const queryChartType = {
    OUTPATIENT_VS_INPATIENT: "OUTPATIENT_VS_INPATIENT",
    INPATIENT_BY_RELATIONSHIP: "INPATIENT_BY_RELATIONSHIP",
    OUTPATIENT_BY_RELATIONSHIP: "OUTPATIENT_BY_RELATIONSHIP",
    TOP_DIAGNOSES: "TOP_DIAGNOSES",
    MOST_USED_OUTPATIENT_PROVIDERS: "MOST_USED_OUTPATIENT_PROVIDERS",
    MOST_USED_INPATIENT_PROVIDERS: "MOST_USED_INPATIENT_PROVIDERS",
    SEVERITY_FREQUENCY: "SEVERITY_FREQUENCY",
    MOST_USED_PROVIDERS: "MOST_USED_PROVIDERS",
    DIAGNOSES_BY_GENDER: "DIAGNOSES_BY_GENDER"
}

export type QueryChartTypeKey = typeof queryChartType[keyof typeof queryChartType];

export const initCubeInquiry = {dimension: "", query: {measures: [], filters: []}};